/* eslint-disable import/no-duplicates */
/* eslint-disable no-undef */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// 组件头部
import header from '../components/header/header'
// 组件尾部
import footer from '../components/footer/footer'
// 组件右部分(赛事新闻)
import section from '../components/section/section'
// 首页
import index from '../components/page/index'
// 赛事信息
import competition from '../components/page/competition'
// 赛事详情
import Tournament from '../components/page/Tournament'
// 新闻报道
import journalism from '../components/page/journalism'
// 新闻详情
import chessnews from '../components/page/chessnews'
// 登录注册
import signIn from '../components/page/signIn'
// 关于我们
import about from '../components/page/about'
// 联系我们
import contact from '../components/page/contact'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    // 组件头部
    {
      path: '/header',
      component: header
    },
    // 组件尾部
    {
      path: '/footer',
      component: footer
    },
    // 组件右部分(赛事新闻)
    {
      path: '/section',
      component: section
    },
    // 登录注册
    {
      path: '/signIn',
      component: signIn
    },
    // 首页
    {
      path: '/index',
      component: index
    },
    // 赛事信息
    {
      path: '/competition',
      component: competition
    },
    // 新闻报道
    {
      path: '/journalism',
      component: journalism
    },
    // 新闻详情
    {
      path: '/chessnews',
      component: chessnews
    },
    // 赛事详情
    {
      path: '/Tournament',
      component: Tournament
    },
    // 关于我们
    {
      path: '/about',
      component: about
    },
    // 联系我们
    {
      path: '/contact',
      component: contact
    },
    // 重定向
    {
      path: '*',
      redirect: '/index'
    }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js